// extracted by mini-css-extract-plugin
export var chatHtmlText = "_ue-2";
export var chatLink = "_ue-0";
export var chatText = "_ue-1";